import { render, staticRenderFns } from "./generalagent.vue?vue&type=template&id=7ad7dc71"
import script from "./generalagent.vue?vue&type=script&lang=js"
export * from "./generalagent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports